import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getOr } from 'lodash/fp';
import * as reportingActions from 'actions/pathBuilder/reporting';
import { hasReportingPermission } from 'selectors/pathBuilder';
import { Icon, Spinner } from 'ui';
import FeatureFlag from 'components/shared/FeatureFlag';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import { routes } from 'constants/config';
import ReportingHeader from './Partials/ReportingHeader';
import ReportingBlockGroup from './Partials/ReportingBlockGroup';
import GroupFilter from './GroupFilter';
import Assignments from './Assignments';
import LearningLibrary from './LearningLibrary';
import Performance from './Performance';
import GradebookButton from './GradebookButton';
import AssignView from './AssignView';
import AncestorPaths from './AncestorPaths';

class Reporting extends PureComponent {
  constructor() {
    super();
    this.handleGroupChange = this.handleGroupChange.bind(this);
    this.state = {
      showSpinner: false,
    };
  }

  componentDidMount() {
    const { groupId } = this.props;
    if (groupId) {
      this.props.setGroup(groupId);
    }
    this.props.fetchData(groupId);
  }

  handleGroupChange(groupId) {
    this.props.setGroup(groupId);
    this.props.fetchData(groupId);
  }

  render() {
    const {
      canViewAncestors,
      canViewGradebook,
      groupId,
      loading,
      pathId,
      viewAssign,
      viewGroupFilter,
      viewLibraryStats,
      viewActivity,
    } = this.props;
    return (
      <div className="PathReporting mt-48">
        {viewAssign && <AssignView onAssign={() => window.location.reload()} />}
        <ReportingHeader>
          <div className="d-f fd-r ai-b">
            {viewGroupFilter && (
              <GroupFilter
                groupId={groupId}
                onChange={this.handleGroupChange}
              />
            )}
            <FeatureFlag features="embedded_insights_page">
              {this.state.showSpinner ? (
                <Spinner className="mb-4 pl-16" />
              ) : (
                <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="mb-4 pl-16">
                  <a
                    href={routes.PATH_REPORTING.DOWNLOAD_REPORT(
                      pathId,
                      groupId,
                    )}
                    className="DataCard-link"
                    onClick={() => this.setState({ showSpinner: true })}
                  >
                    <Icon name="download" />
                    {t('actions.download_path_progress_report')}
                  </a>
                </Text>
              )}
            </FeatureFlag>
          </div>
          {canViewGradebook && <GradebookButton />}
        </ReportingHeader>
        <ReportingBlockGroup>
          {viewActivity && <Assignments />}
          {viewLibraryStats && <LearningLibrary />}
          <Performance loading={loading} />
          {canViewAncestors && <AncestorPaths />}
        </ReportingBlockGroup>
      </div>
    );
  }
}

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  canViewAncestors: hasReportingPermission(pathBuilder, 'viewAncestors'),
  canViewGradebook: hasReportingPermission(pathBuilder, 'viewGradebook'),
  groupId: pathBuilder.reporting.groupId,
  loading: getOr(true, 'loading')(pathBuilder.reporting),
  pathId: pathBuilder.id,
  viewAssign: hasReportingPermission(pathBuilder, 'viewAssign'),
  viewGroupFilter: hasReportingPermission(pathBuilder, 'viewGroupFilter'),
  viewLibraryStats: hasReportingPermission(pathBuilder, 'viewLibraryStats'),
  viewActivity: hasReportingPermission(pathBuilder, 'viewActivity'),
});

const mapDispatchToProps = {
  setGroup: reportingActions.setGroup,
  fetchData: reportingActions.fetchData,
};

export default connect(mapStateToProps, mapDispatchToProps)(Reporting);
